import { defineMessages } from 'react-intl';

const currencyLocalMessages = defineMessages({
    learnMoreLink: {
        id: 'currencyLocalePicker.currencyLocaleMessages.learnMore',
        description: 'Learn More Link',
        defaultMessage: 'Set where you live and what language you speak.'
    },
    updateSettingsTitle: {
        id: 'currencyLocalePicker.currencyLocaleMessages.updateSettingsTitle',
        description: 'Update your settings',
        defaultMessage: 'Update your settings'
    },
    saveButtonText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.save',
        description: 'Save button text',
        defaultMessage: 'Save'
    },
    cancelButtonText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.cancel',
        description: 'Cancel button text',
        defaultMessage: 'Cancel'
    },
    currencyLabelText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.currencyLabelText',
        description: 'Currency label text for currency picker',
        defaultMessage: 'Currency'
    },
    languageLabelText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.languageLabelText',
        description: 'Language label text for language picker',
        defaultMessage: 'Language'
    },
    physicalCardText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.physicalCardText',
        description: ' physicalCard text',
        defaultMessage: 'physical cards'
    },
    dialogTitleText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.dialogTitleText',
        description: 'Switch sites to shop text',
        defaultMessage: 'Switch sites to shop in {dialogTitleText}'
    },
    continueButtonText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.continueButtonText',
        description: 'Continue to site button text',
        defaultMessage: 'Continue to site'
    },
    physicalCardTypographyText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.physicalCardTypographyText',
        description: ' physicalCard typography text',
        defaultMessage: 'You can buy physical cards from our older website - we’re still working on it here. Do you want to continue?'
    },
    currencyTypographyText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.currencyTypographyText',
        description: ' currency typography text',
        defaultMessage: 'You can shop in {currencyName} ({currency}) on our older site - we’re still working on it here. Do you want to continue?'
    },
    languageTypographyText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.languageTypographyText',
        description: ' language typography text',
        defaultMessage: 'You can shop in {language} on our older site - we’re still working on it here. Do you want to continue?'
    },
    changeCurrencyAlertText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.changeCurrencyAlertText',
        description: ' change currency alert text',
        defaultMessage: 'Only one currency allowed per order. You can buy other currencies in a separate order.'
    },
    CurrencyNotAvailableSummary: {
        id: 'currencyLocalePicker.currencyLocaleMessages.CurrencyNotAvailableSummary',
        description: 'Currency not available summary',
        defaultMessage: `{pendingCardType} cards are not available in your chosen currency <b>{selectedCurrencyWithSymbol}</b>.
                    Your currency has been reset to {defaultCurrencyWithSymbol}.
                    <br>
                    You can shop for {pendingCardType} cards in {currencyListString}`
    },
    continueSwitchCurrencyButtonText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.continueSwitchCurrencyButtonText',
        description: 'Continue to switch currency button text',
        defaultMessage: 'Continue'
    },
    CurrencyNotAvailableText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.CurrencyNotAvailableText',
        description: 'Currency not available title text',
        defaultMessage: 'Currency not available'
    },
    gotItButtonText: {
        id: 'currencyLocalePicker.currencyLocaleMessages.gotItButtonText',
        description: 'Got it button text',
        defaultMessage: 'Got it'
    }
});

export default currencyLocalMessages;
